module.exports = __webpack_public_path__ + "img/result3.fd5c2b8b.png";